import { EventType, EventTypeDetailed } from "@/types";

import { axios } from "../axios.instance";

export type GetEventRequest = {
  eventId: EventType["id"];
};

export type GetEventResponse = EventType & EventTypeDetailed;

export const getEvent = async (params: GetEventRequest): Promise<GetEventResponse> => {
  const { data } = await axios.get(`/events/${params.eventId}`);

  return data;
};
